import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import {
  Badge,
  Box,
  Button,
  Grow,
  IconButton,
  InputAdornment,
  Tooltip,
} from '@mui/material';
import {
  GridToolbar,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';
import { useState } from 'react';
import PresetSelector from '@/components/datagrid/PresetSelector';

const EnergyXplorerToolbar = ({ ...props }) => {
  const [showToolbar, setShowToolbar] = useState(false);

  return (
    <GridToolbarContainer
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 1,
        background: 'inherit',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <GridToolbarQuickFilter
          size="small"
          sx={{
            mr: 1,
            '& .MuiInputBase-root': {
              backgroundColor: (theme) => theme.palette.background.paper,
              borderRadius: 2,
            },
            '& .MuiFilledInput-root': {
              borderRadius: '5px',
            },
            '& .MuiInput-underline:before, & .MuiInput-underline:after': {
              display: 'none',
            },
            '& .MuiInputLabel-root': {
              color: 'gray',
            },
          }}
          variant="outlined"
          InputProps={{
            placeholder: 'Søg...',
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ color: 'gray' }} />
              </InputAdornment>
            ),
          }}
        />
        <PresetSelector {...props} />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Grow in={showToolbar}>
          <GridToolbar />
        </Grow>

        <Badge
          color="primary"
          badgeContent={props.filterModel?.items?.length || 0}
          invisible={!(props.filterModel?.items?.length > 0)} // hide badge when no filters
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          slotProps={{
            badge: {
              sx: {
                // Pull the badge INSIDE the button so it won't be clipped
                top: -7,
                right: -7,
                transform: 'none', // cancel default translate(50%, -50%)
                zIndex: 1,
              },
            },
          }}
        >
          <Button
            startIcon={showToolbar ? <FilterListOffIcon /> : <FilterListIcon />}
            variant="outlined"
            size="small"
            onClick={() => setShowToolbar(!showToolbar)}
            sx={{
              borderRadius: 2,
              borderColor: 'divider',
              backgroundColor: 'background.paper',
              textTransform: 'none',
              p: 0.9,
              mt: -0.5,
              color: 'text.primary',
            }}
          >
            {showToolbar ? 'Skjul indstillinger' : 'Vis indstillinger'}
          </Button>
        </Badge>
      </Box>
    </GridToolbarContainer>
  );
};

export default EnergyXplorerToolbar;
